import config from 'config'
import {Optional} from 'data/types'
import {uniqueId} from 'lodash'
import {Subject} from 'rxjs'

declare global {
  interface Window {
    chrome: any
  }
}

type ItxChromeService = 'background' | 'contentApp' | 'popupApp'

export default class ChromeExtensionRequestor {
  private extensionEvents = new Subject<{event: any; sendResponse: (data: any) => void}>()
  private isSubscribed = false

  public get events() {
    if (!this.isSubscribed) {
      window.chrome?.runtime?.onMessage?.addListener((message: any, sender: any, sendResponse: any) => {
        this.extensionEvents.next({event: message, sendResponse})
        return true
      })
    }
    return this.extensionEvents.asObservable()
  }

  private sendMessage = <V = any>(message: any) => {
    return new Promise<V>((fulfill) => {
      window.chrome?.runtime.sendMessage(null, message, fulfill)
    })
  }

  public exec = async <V = any>(service: ItxChromeService, method: string, payload?: any): Promise<Optional<V>> => {
    if (config.shouldTestChromeApp) {
      let chromeService
      const services = await import('services')
      switch (service) {
        case 'contentApp':
          chromeService = services.default.getChromeContentService()
          break
        case 'popupApp':
          chromeService = services.default.getChromePopupService()
          break
        case 'background':
          const ChromeStubBackgroundService = (await import('./ChromeStubBackgroundService')).default
          chromeService = new ChromeStubBackgroundService()
          break
      }

      // @ts-ignore
      return (await chromeService[method]?.(payload)) ?? null
    }

    const requestId = uniqueId()
    const message = {
      method,
      payload,
      requestId,
      itx: service,
    }
    const response = await this.sendMessage(message)
    return response
  }
}
